import { render, staticRenderFns } from "./MigrationMemberTable.vue?vue&type=template&id=4612e074&scoped=true&"
import script from "./MigrationMemberTable.vue?vue&type=script&lang=js&"
export * from "./MigrationMemberTable.vue?vue&type=script&lang=js&"
import style0 from "./MigrationMemberTable.vue?vue&type=style&index=0&id=4612e074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612e074",
  null
  
)

export default component.exports